module.exports = __webpack_public_path__ + "img/8market5_dog2.d51cd042.png";